import React, { useContext, useEffect, useRef, useState } from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Sport1 from '../assets/Sports1.png'
import Sport2 from '../assets/Sports2.png'
import Sport3 from '../assets/Sports3.png'
import Sport4 from '../assets/Sports4.png'
import Girl from '../assets/GirlAlbumimg.png'
import Albumimg2 from '../assets/Albumimg2.png'
import Albumimg3 from '../assets/Albumimg3.png'
import Albumimg4 from '../assets/Albumimg4.png'
import Albumimg5 from '../assets/Albumimg5.png'
import { EventsContext } from '../context/EventsContext';
import { useNavigate } from 'react-router-dom';
import { NavbarContext } from '../context/NavbarContext';
import { getAppData } from '../apiService';

function Album() {

  const { albumId, allAlbums, mySlider, setMySlider, images, setImages, toShow, setToShow } = useContext(EventsContext);
  const { navHeading, setNavHeading } = useContext(NavbarContext);
  // const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const sliderRef = useRef(null);
  //   const images = [
  //     Sport1,Sport2,Sport3,Sport4,Girl,Albumimg2,Albumimg5,Albumimg4,Albumimg3,Sport1,Sport2,Sport3,Sport4,Girl,Albumimg2,Albumimg5,Albumimg4,Albumimg3,Albumimg4,Albumimg3,Girl,Albumimg2,Albumimg5,Albumimg4
  // ]
  // const images = Array.from({ length: 155 }, (_, i) => `https://picsum.photos/200/300?random=${i + 1}`);
  // const images = Array.from({ length: 99 }, (_, i) => `https://randomuser.me/api/portraits/women/${i + 1}.jpg`);
  // const images = Array.from({ length: 155 }, (_, i) => `https://unsplash.it/${i + 200}/200/`);


  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    rows: 2,
    arrows: false,
  };

  useEffect(() => {
    if (!albumId) {
      // alert("Id not Found");
      navigate("/albums");
    }
  }, [albumId, navigate]);

  useEffect(() => {
    if (albumId && allAlbums) {
      const album = allAlbums.find((item) => item.id == albumId)
      setImages(album.images)
      setNavHeading(album.title)
      // images.unshift(album.image)
    }

  }, [albumId, allAlbums])
  useEffect(() => {
    // console.log(images," images");

  }, [images])

  if (!allAlbums) {
    return (
      <div className="loader-container">
        <div className="dot-wave-loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <>
        <div className="blur-background"></div>
        <div className="error-container">
          <p>{error}</p>
        </div>
      </>
    )
  }


  // const allAblums = [
  //     { id: "hjkllihdvhjt4311", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4322", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4333", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4344", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
  //     { id: "hjkllihdvhjt4315", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4326", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4337", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4348", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
  //     { id: "hjkllihdvhjt4319", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4320", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4331", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4342", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
  //     { id: "hjkllihdvhjt4313", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4324", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4335", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4346", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
  //     { id: "hjkllihdvhjt4317", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4328", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4339", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4341", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
  //     { id: "hjkllihdvhjt4312", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4323", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4334", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4345", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },
  //     { id: "hjkllihdvhjt4316", name: "Imagine Sports", time: "Weekly series", image: `${Sport1}` },
  //     { id: "hjkllihdvhjt4327", name: "Lets Argue", time: "Monthly Once", image: `${Sport2}` },
  //     { id: "hjkllihdvhjt4338", name: "Bills Tales", time: "Weekly series", image: `${Sport3}` },
  //     { id: "hjkllihdvhjt4349", name: "Succes in field", time: "Monthly Twice", image: `${Sport4}` },

  // ] 



  return (
    <>
      {albumId && allAlbums ? <div className='layout7-div'>

        <div className='Album-main-div-outer'>
          <div className="slider-container">
            <button className="slider-arrow left" onClick={() => sliderRef.current.slickPrev()}>
              <FaChevronLeft />
            </button>

            <div className="slider-wrapper">
              <Slider ref={sliderRef} {...settings}>
                {images && images.length > 0 ? (
                  <>
                    {images.map((item, index) => (
                      <div key={index} className="slide-item">
                        <div className="slider-d-jhu"><img src={item} alt={`Slide ${index}`} style={{ width: "100%", height: "100%" }} /></div>
                      </div>
                    ))}</>) : (<div className="slider-d-jhu">No image available</div>)}
              </Slider>
            </div>

            <button className="slider-arrow right" onClick={() => sliderRef.current.slickNext()}>
              <FaChevronRight />
            </button>
          </div>
        </div>
        <div className='Album-main-div-outer-for-desktop-and-laptop-screen-12345'>
          {images && images.length > 0 ? (
            <>
              {images.map((item, index) => (
                <div className='album-single-div-with-image-for-desktop-and-laptop-screen-12345' key={index} onClick={() => { setMySlider(true); setToShow(index) }}>
                  <img
                    src={item}
                    alt={`Image ${index}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",  // Ensures the image covers the area like a background
                      borderRadius: "5px",  // Matching the border-radius from CSS
                    }}
                  />
                </div>
              ))}
            </>
          ) : (
            <div className='album-single-div-with-image-for-desktop-and-laptop-screen-12345'>No images available</div>
          )}
        </div>

        {/* <div className='Album-main-div-outer-for-phonr-screen-12345'>
  {images && images.length > 0 ? (
    <>
    
      {images.map((item, index) => (
        <div className='album-single-div-with-image-for-phone-screen-12345' key={index}>
          <img
            src={item}
            alt={`Image ${index}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",  // Ensures the image fills the div similarly to background-image
              borderRadius: "8px",  // Matching the border-radius from CSS
            }}
          />
        </div>
      ))}
    </>
  ) : (
    <div className='album-single-div-with-image-for-phone-screen-12345'>No images available</div>
  )}
</div> */}




      </div> : <div className='layout7-div'>data Not Found </div>}
    </>
  )
}

export default Album